import React from 'react';
import { CheckCircle2 } from 'lucide-react';

export function SuccessSheet() { 
    
return (
  <div className="absolute inset-0 bg-black/20 flex items-end z-50 animate-in fade-in duration-300">
    <div className="w-full bg-white rounded-t-[40px] p-10 flex flex-col items-center animate-in slide-in-from-bottom-full duration-500">
      <div className="w-12 h-1 bg-gray-200 rounded-full mb-10" />
      
      <div className="relative mb-8">
        <div className="absolute inset-0 bg-green-100 rounded-full scale-150 animate-pulse" />
        <CheckCircle2 size={80} className="text-green-500 relative z-10" strokeWidth={1.5} />
      </div>

      <h2 className="text-2xl font-black uppercase mb-4">Email Verified</h2>
      <p className="text-gray-500 text-center mb-6">
        Your email has been successfully verified!
      </p>
    </div>
  </div>
);
}